<script>
    import Header from "./header-section.svelte";
    import { delivering_detail, delivering_detail_mob } from "./header_data.js";
    import Button from "./button.svelte";
    import { fade } from "svelte/transition";
    import YourPlan from "./submit_your_plan.svelte";
    import Footer from "./footer.svelte";
    import PopUpButton from "./popUp_button.svelte";
    import { title, show } from "./store.js";
    import { current_component, fix_position } from "svelte/internal";
    title.set("Home");

    let work_with = [
        {
            src: "/images/home_page/general_contractors.png",
            title: "General Contractors",
        },
        {
            src: "/images/home_page/sub_contractors.png",
            title: "Sub Contractors",
        },
        {
            src: "/images/home_page/homebuilders.png",
            title: "Homebuilders",
        },
        {
            src: "/images/home_page/developer.png",
            title: "Developers",
        },
        {
            src: "/images/home_page/remodling_contractors.png",
            title: "Remodeling <br> Contractors",
        },
        {
            src: "/images/home_page/architects.png",
            title: "Architects",
        },
    ];

    let our_services = [
        {
            icon: "/images/home_page/design_analysis_icon.svg",
            title: "Design & <br> ANALYSIS",
            description:
                "We aim to find the most creative, cost-effective solution to every design and to keep projects on budget and on time. As a result, we have clients happily return to us with their next projects <br><br> When your project is ready for design, we have your solutions.",
            pagelink: "/design_analysis",
        },
        {
            icon: "/images/home_page/estimation_icon.svg",
            title: "Estimation",
            description:
                "We execute all kind of material estimation i.e steel, concrete, masonry, wood paint and other finishes<br><br>We also work in infrastructure quantities take off including road and earth work quantities.",
            pagelink: "/estimate_service",
        },
        {
            icon: "/images/home_page/drafting_services_icon.svg",
            title: "DRAFTING <br> SERVICES",
            description:
                "You will need a clear drafting plan to prevent confusion and save time and money during the construction process.",
            pagelink: "/drafting_service",
        },
    ];

    let our_services_mbl = [
        {
            icon: "/images/home_page/design_analysis_icon.svg",
            title: "Design & <br> ANALYSIS",
            description:
                "We aim to find the most creative, cost-effective solution to every design and to keep projects on budget and on time. As a result, we have clients happily return to us with their next projects <br><br> When your project is ready for design, we have your solutions.",
            pagelink: "/design_analysis",
            border_color: "0.7vw solid #B3E1D3",
            list_items1: [
                "Foundation Design",
                "Specialty Engineering & Design",
                "Architectural Design",
                "MEP design",
                "Design of Building Framing  Systems",
            ],
            list_items2: [
                "Project & Cost Management",
                "Infrastructure Design",
                "Bridge Engineering",
                "Construction Engineering",
                "Review & Modification of  Existing  Structures",
            ],
        },
        {
            icon: "/images/home_page/estimation_icon.svg",
            title: "Estimation",
            description:
                "We execute all kind of material estimation i.e steel, concrete, masonry, wood paint and other finishes<br><br>We also work in infrastructure quantities take off including road and earth work quantities.",
            pagelink: "/estimate_service",
            border_color: "0.7vw solid #AED2FE",
            list_items1: [
                "Quantity Survey",
                "Quantity Takeoff",
                "Bill of Materials",
                "Structural Steel Takeoff",
                "Rebar quantity take off",
                "Rebar scheduling",
            ],
            list_items2: [
                "Concrete Frame structures",
                "Steel frame",
                "Hybrid industrial structures",
                "Masonry",
                "Wood and other structures",
            ],
        },
        {
            icon: "/images/home_page/drafting_services_icon.svg",
            title: "DRAFTING <br> SERVICES",
            description:
                "You will need a clear drafting plan to prevent confusion and save time and money during the construction process.",
            pagelink: "/drafting_service",
            border_color: "0.7vw solid #FDE8C0",
            list_items1: [
                "AS Builds Preparation",
                "Redline Markup Incorporation",
                "Rebar scheduling",
                "Rebar shop drawings",
                "Road Layouts",
                "Removals",
            ],
            list_items2: [
                "Concrete and other lements Shop drawings",
                "Structural Steel Fabrication Drawings",
            ],
        },
    ];
    let services_provided = [
        {
            border_color: "90deg, #6AC5AB 0%, #1EB33F 100%",
            list_items: [
                "Foundation Design",
                "Specialty Engineering & Design",
                "Architectural Design",
                "MEP design",
                "Design of Building Framing Systems",
                "Project & Cost Management",
                "Infrastructure Design",
                "Bridge Engineering",
                "Construction Engineering",
                "Review & Modification of Existing Structures",
            ],
        },

        {
            border_color: "90deg, #66C8FF 0%, #5383FB 100%",
            list_items: [
                "Quantity Survey",
                "Quantity Takeoff",
                "Bill of Materials",
                "Structural Steel Takeoff",
                "Rebar quantity take off",
                "Rebar scheduling",
                "Concrete Frame structures",
                "Steel frame",
                "Hybrid industrial structures",
                "Masonry",
                "Wood and other structures",
            ],
        },
        {
            border_color: "90deg, #FFC700 0%, #FFA666 100%",
            list_items: [
                "AS Builds Preparation",
                "Redline Markup Incorporation",
                "Rebar scheduling",
                "Rebar shop drawings",
                "Road Layouts",
                "Removals",
                "Concrete and other lements Shop drawings",
                "Structural Steel Fabrication Drawings",
            ],
        },
    ];

    let slides = [
        {
            slider_img: "/images/home_page/engr_usman_nasir.png",
            des: "I’m impressed with the accuracy of the estimates and the quality of the services they provide. Consulting with automason helped us get a lot of bids and a full breakdown of the costs. I was happy with the timely response they gave and will surely use their services again. I highly recommend this service. ",
            name: "Engr. Usman Nasir",
            job_company: "Director, Artico Constructions Pakistan",
        },
        {
            slider_img: "/images/home_page/hamza_bilal.png",
            des: "Automason is a great tool for construction consultation. They provide fast delivery and exceptional service within the shortest turnaround times. Their team is excellent and communication was very thorough.I found this service to have very detailed reports which helped my business a lot with bids. Very happy with the results!",
            name: "Hamza Bilal",
            job_company: "Structural Engineer, IBI Group USA",
        },
        {
            slider_img: "/images/home_page/tariq_mehmood.png",
            des: "The services automason provide are very professional and organized. As a contractor, I expect plan take offs to be of a very high standard and automason delivered very well. The estimates I received were very accurate and the response time was very fast. Overall I was very satisfied with their software and the end result. The best part was how easy and simple the whole process was to use. I will definitely avail this service again.",
            name: "Tariq Mehmood",
            job_company: "Managing Director, FOTAMA Hong Kong",
        },
        {
            slider_img: "/images/home_page/rehan_ul_haq.png",
            des: "Automason was the solution our business was looking for! We have been using this service for our big projects which turned out to be very successful. Thanks to automason, we were able to budget properly and have precise estimates. The service provided was quick and the quantities very accurate so we could rely on them effectively. I would definitely recommend it to all contractors.",
            name: "Rehan ul-Haq",
            job_company:
                "Director, Alkhorayef Water and Power Technologies Dubai",
        },
        {
            slider_img: "/images/home_page/ReNadeem.png",
            des: "The service is easy to use, affordable and fast. I was able to gain accurate estimates for material takeoffs and get quality bids. I appreciated the customer service which was very professional. Automason really impressed me with their efficiency and reliability. I am ready and confident to hand over my plans to them anytime for a skilled performance. ",
            name: "ReNadeem Hussain Malik",
            job_company: "Managing Director, AAN Consulting Engineers",
        },
    ];
    let slides_mob = [
        {
            slider_img: "/images/home_page/engr_usman_nasir.png",
            des: "<span style='    position: relative;top: -4vw;'>I’m impressed with the accuracy of the estimates and the quality of the services they provide. Consulting with automason helped us get a lot of bids and a full breakdown of the costs. I was happy with the timely response they gave and will surely use their services again. I highly recommend this service. </span>",
            name: "<span>Engr. Usman Nasir</span>",
            job_company: "<span>Director, Artico Constructions Pakistan</span>",
        },
        {
            slider_img: "/images/home_page/hamza_bilal.png",
            des: "<span style='    position: relative;top: -4vw;'>Automason is a great tool for construction consultation. They provide fast delivery and exceptional service within the shortest turnaround times. Their team is excellent and communication was very thorough.I found this service to have very detailed reports which helped my business a lot with bids. Very happy with the results!</span>",
            name: "<span>Hamza Bilal</span>",
            job_company: "<span>Structural Engineer, IBI Group USA</span>",
        },
        {
            slider_img: "/images/home_page/tariq_mehmood.png",
            des: "<span style='    position: relative;top: -4vw;'>The services automason provide are very professional and organized. As a contractor, I expect plan take offs to be of a very high standard and automason delivered very well. The estimates I received were very accurate and the response time was very fast. Overall I was very satisfied with their software and the end result. The best part was how easy and simple the whole process was to use. I will definitely avail this service again.</span>",
            name: "<span style='position: relative;top: 1.85vw;'>Tariq Mehmood</span>",
            job_company:
                "<span style='position: relative;top: 1.2vw;'>Managing Director, FOTAMA Hong Kong</span>",
        },
        {
            slider_img: "/images/home_page/rehan_ul_haq.png",
            des: "<span style='    position: relative;top: -4vw;'>Automason was the solution our business was looking for! We have been using this service for our big projects which turned out to be very successful. Thanks to automason, we were able to budget properly and have precise estimates. The service provided was quick and the quantities very accurate so we could rely on them effectively. I would definitely recommend it to all contractors.</span>",
            name: "<span style='position:relative;top:1.2vw'>Rehan ul-Haq</span>",
            job_company:
                "<span style='position:relative;top:0.85vw'>Director, Alkhorayef Water and Power Technologies Dubai </span>",
        },
        {
            slider_img: "/images/home_page/ReNadeem.png",
            des: "<span style='position: relative;top: -4vw;'>The service is easy to use, affordable and fast. I was able to gain accurate estimates for material takeoffs and get quality bids. I appreciated the customer service which was very professional. Automason really impressed me with their efficiency and reliability. I am ready and confident to hand over my plans to them anytime for a skilled performance. </span>",
            name: "<span style='position: relative;top: 1.5vw;'>ReNadeem Hussain Malik</span>",
            job_company:
                "<span style='position: relative;top: 1.05vw;'>Managing Director, AAN Consulting Engineers</span>",
        },
    ];
    let currentAnim = "start";
    let cur = 0;
    let cur_mob = 0;
    const clamp = (number, min, max) => Math.min(Math.max(number, min), max);
    const transition_args = {
        duration: 200,
    };
    console.log("slides leng", slides.length);
    function prev(e) {
        cur = clamp(--cur, 0, slides.length - 1);
        if (cur === 3) {
            currentAnim = "nextSlide3";
        } else if (cur === 2) {
            currentAnim = "slidePrev";
        } else if (cur === 1) {
            currentAnim = "nextSlide";
        } else if (cur === 0) {
            currentAnim = "start";
        }
        console.log("Prev", currentAnim);
    }
    function next(e) {
        cur = clamp(++cur, 0, slides.length - 1);
        if (cur === 0) {
            currentAnim = "start";
        } else if (cur === 2) {
            currentAnim = "slidePrev";
        } else if (cur === 1) {
            currentAnim = "nextSlide";
        } else if (cur === 3) {
            currentAnim = "nextSlide3";
        } else if (cur === 4) {
            currentAnim = "nextSlide4";
        }
        console.log("currentAnim", currentAnim);
    }
    let position_1 = 0;
    let position_2 = 356;
    let position_3 = 712;
    let position_4 = 1068;
    let position_5 = 1422;
    function nextslide() {
        cur_mob = clamp(++cur_mob, 0, slides.length - 1);
        if (scrol.scrollLeft < 356) {
            scrol.scrollLeft = position_2;
        } else if (scrol.scrollLeft < 712) {
            scrol.scrollLeft = position_3;
        } else if (scrol.scrollLeft < 1068) {
            scrol.scrollLeft = position_4;
        } else if (scrol.scrollLeft >= 1068) {
            scrol.scrollLeft = position_5;
        }
    }
    function prevslide() {
        cur_mob = clamp(--cur_mob, 0, slides.length - 1);
        if (scrol.scrollLeft <= 356) {
            scrol.scrollLeft = position_1;
        } else if (scrol.scrollLeft <= 712) {
            scrol.scrollLeft = position_2;
        } else if (scrol.scrollLeft <= 1068) {
            scrol.scrollLeft = position_3;
        } else if (scrol.scrollLeft >= 1068) {
            scrol.scrollLeft = position_4;
        }
    }
    const ARROW_LEFT = 37;
    const ARROW_RIGHT = 39;
    function handleShortcut(e) {
        if (e.keyCode === ARROW_LEFT) {
            prev();
        }
        if (e.keyCode === ARROW_RIGHT) {
            next();
        }
    }
    $: console.log("current slide", cur);

    function displayPopUp() {
        show.update((n) => n + 1);
        console.log("show", show);
    }

    let class_name;
    let scrol;
    let dots_con;
</script>

<svelte:window on:keyup={handleShortcut} />
<Header data_desktop={delivering_detail} data_mobile={delivering_detail_mob} />
<YourPlan />
<section>
    <div class="desktop">
        <div style="overflow:hidden;">
            <div class="title">
                <h2
                    style=" margin-top:5.5vw; font-size: 2.083vw; text-align:center; width: 70.281vw; color : rgba(0, 0, 0, 1);"
                >
                    We strive to provide you with affordable rates and market
                    effective strategies to bid and close projects.
                </h2>
            </div>
            <div class="des">
                <p style="font-size: 1.247vw; margin:0;">
                    We know that your time is limited so we make sure to have
                    quick results with high accuracy.
                </p>
            </div>
            <div class="images-text">
                <div style="width: 57.212vw;">
                    <div class="circle-img">
                        <img
                            src="/images/home_page/circle.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="map-img">
                        <img
                            src="/images/home_page/map.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="card-1">
                        <div class="card-layout">
                            <div class="title">
                                <h2>Estimator Network</h2>
                            </div>
                            <div class="card-img">
                                <img
                                    src="/images/home_page/card1.png"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="projects">
                                <div class="project-img">
                                    <img
                                        src="/images/home_page/star.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div class="project-text">
                                    <h2>40+ Projects</h2>
                                </div>
                            </div>
                            <div class="project-status">
                                <h4>Completed</h4>
                            </div>
                        </div>
                    </div>
                    <div class="card-2">
                        <div class="card-layout">
                            <div class="title">
                                <h2>Dynamic Takeoffs</h2>
                            </div>
                            <div class="card-img">
                                <img
                                    src="/images/home_page/card2.png"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                            <div class="projects">
                                <div
                                    class="project-img"
                                    style="margin-left: 1.611vw;"
                                >
                                    <img
                                        src="/images/home_page/star.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div class="project-text">
                                    <h2>10+ Years</h2>
                                </div>
                            </div>
                            <div
                                class="project-status"
                                style="margin-left: 3.1vw;"
                            >
                                <h4>Experience</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div style="margin-bottom: 1.5vw;">
                        <div class="choose-us-img">
                            <img src="images/home_page/choose_us.svg" alt="" />
                        </div>
                    </div>

                    <div
                        style=" width:33.472vw; height:8.628vw; margin-top: 0.616vw;"
                    >
                        <h2 style="font-size: 1.559vw; margin:0;">
                            We strive to make your project a construction
                            masterpiece, something unique and unrivaled.
                        </h2>
                    </div>
                    <div class="choose-us-para">
                        <h5 style="font-size: 0.936vw; margin:0;">
                            We help you work the numbers when you’re
                            negotiating, and even jump on a conference call with
                            your client (as your estimating team) to help you
                            close.
                        </h5>
                        <h5 style="font-size: 0.936vw; margin:0;">
                            We even advise you on exactly WHAT TO DO to have
                            them wanting to USE YOU instead of your competitor.
                        </h5>
                    </div>
                    <div style="margin-top: 1.9vw;">
                        <Button
                            border_radius="0.625vw"
                            padding="1.299vw 2.079vw"
                            title="Explore Now"
                            me="2"
                            btnStyle="nav_bar_btn"
                            px="0"
                            href="#our_services"
                        />
                    </div>
                </div>
            </div>

            <div class="project-contracts">
                <div class="icon">
                    <img
                        src="/images/home_page/light_icon.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div style="margin-top: 2.703vw;">
                    <div style="width: 41.892vw; text-align:center;">
                        <h2 style="font-size: 1.247vw;color:white;">
                            Most contractors are missing out on over $200,000
                            per month in project contracts and they don’t even
                            know it.
                        </h2>
                    </div>
                    <div style="width: 41.580vw; text-align:center;">
                        <h5 style="color:white;">
                            They are busy, have no time for estimating, and they
                            are leaving money on the table. A lot of money. We
                            designed our construction estimating service with
                            the goal of helping our clients win projects and
                            ultimately be successful
                        </h5>
                    </div>
                </div>
            </div>

            <div class="construction-business">
                <div style="margin-left: 13.202vw;">
                    <div
                        style="margin-bottom: 2vw;"
                    >
                        <h1 style=" font-size: 2.5vw;
                        width: 31vw;
                        font-weight: 600;
                        color: rgb(25, 25, 25);
                        margin: 0vw;
                        line-height: 110%;
                        text-transform: uppercase;">It works for any <br>construction<br> business.</h1>
                    </div>
                    <div style="width: 26.455vw;">
                        <h5 style="color: rgba(25, 25, 25, 1);margin: 0vw;">
                            These aren’t strategies we made up – we listened to
                            our clients and created our blueprint based on what
                            they are doing right, and avoiding what they were
                            doing wrong.
                        </h5>
                    </div>
                </div>
                <div style="margin-top: -8vw;
                margin-left: 5vw;
                width: 44.344vw;">
                    <img src="/images/home_page/group_img.png" width=100% alt=""/>
                </div>
                <!-- <div
                    class="construction-business-imgs"
                    style="
                margin-top: -7.5vw;" >
                    <div class="stroke1" />
                    <div class="stroke2" />
                    <div class="construction-business-img">
                        <img
                            src="/images/home_page/construction_business.png"
                            alt=""
                        />
                    </div>
                    <div class="construction-site-img">
                        <img
                            src="/images/home_page/construction_site.png"
                            alt=""
                        />
                    </div>
                </div> -->
            </div>
            <div class="work-with">
                <div class="work-with-text">
                    <div style="width: 25.219vw;">
                        <h1
                            style="margin: 0; color:
                        rgba(25, 25, 25, 1);
                        
    font-size: 2.5vw;
    "
                        >
                            WE WORK WITH
                        </h1>
                    </div>
                    <div class="work-with-para">
                        <h5
                            style="; color:
                        rgba(25, 25, 25, 1);
                        margin-top:-2.5vw;"
                        >
                            We work with industry professionals that provide you
                            with error-free results. If you’re a homebuilder,
                            builder, architect or a sub-contractor, you’ve come
                            to the right place.
                        </h5>
                    </div>
                    <div >
                        <PopUpButton
                            border_radius="0.625vw"
                            padding="1.299vw 2.079vw"
                            title="Get Started"
                            me="2"
                            btnStyle="nav_bar_btn"
                            px="0"
                            on:click={() => {
                                displayPopUp();
                            }}
                        />
                    </div>
                </div>
                <div style=" margin-top: 5.4vw; margin-left: 10vw;">
                    <div class="gallery">
                        {#each work_with as data}
                            <div class="gallery_tab">
                                <img src={data.src} alt="" />
                                <div class="title">
                                    <h3 style="margin: 0;">
                                        {@html data.title}
                                    </h3>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>

            <div>
                <span id="our_services" />
                <div class="our-services-title">
                    <div class="our-services-dotted-img">
                        <img
                            src="images/home_page/services_dots_lines.svg"
                            alt=""
                        />
                    </div>
                    <div style="position: relative;">
                        <h1>OUR SERVICES</h1>
                    </div>
                </div>
                <div class="services">
                    <div class="services-detail">
                        {#each our_services as service}
                            <div style="margin-bottom: 8.177vw;">
                                <div class="icon_text">
                                    <div class="icon-wrapper">
                                        <img src={service.icon} alt="" />
                                    </div>
                                    <div class="icon-detail">
                                        <h1
                                            style="font-size: 2.083vw; margin:0;"
                                        >
                                            {@html service.title}
                                        </h1>
                                    </div>
                                </div>
                                <div class="icon_des">
                                    <h5>{@html service.description}</h5>
                                </div>
                                <div
                                    class="learn-more"
                                    on:click={(e) => {
                                        if (service.pagelink !== "")
                                            location.href = service.pagelink;
                                    }}
                                >
                                    <h5
                                        style="font-weight:500; color:#F36532; margin: 0;"
                                    >
                                        Learn More
                                    </h5>
                                    <div class="learn-more-arrow">
                                        <img
                                            src="/images/home_page/arrow.svg"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>
                        {/each}
                    </div>
                    <div class="services-points">
                        {#each services_provided as service}
                            <div
                                class="outer-border"
                                style=" background-image: linear-gradient({service.border_color});"
                            >
                                <div class="services-content">
                                    <ul
                                        style="display: flex; gap:4.167vw; margin-left: 1.9vw;"
                                    >
                                        <div class="left-right-list ">
                                            <li style="list-style: none;">
                                                <ul>
                                                    {#each service.list_items as item, index}
                                                        {#if index <= 4}
                                                            <li class="myli">
                                                                <h5
                                                                    style="    margin: 0;
                                                            line-height: 2.3vw;"
                                                                >
                                                                    {item}
                                                                </h5>
                                                            </li>
                                                        {/if}
                                                    {/each}
                                                </ul>
                                            </li>
                                        </div>
                                        <div class="left-right-list ">
                                            <li style="list-style: none;">
                                                <ul>
                                                    {#each service.list_items as item, index}
                                                        {#if index > 4}
                                                            <li class="myli">
                                                                <h5
                                                                    style="    margin: 0;
                                                            line-height: 2.3vw;"
                                                                >
                                                                    {item}
                                                                </h5>
                                                            </li>
                                                        {/if}
                                                    {/each}
                                                </ul>
                                            </li>
                                        </div>
                                    </ul>
                                </div>
                            </div>
                        {/each}
                    </div>
                </div>
            </div>

            <div class="featured-clients">
                <div class="featured-clients-dotted-img">
                    <img
                        src="images/home_page/featured-clients_dots_lines.svg"
                        alt=""
                    />
                </div>
                <div class="clients-logo-background">
                    <div class="client-logos">
                        <div style="width: 8.906vw; height: 7.292vw;">
                            <img src="images/home_page/client1.svg" alt="" />
                        </div>
                        <div style="width: 4.375vw; height: 7.240vw;">
                            <img src="images/home_page/client2.svg" alt="" />
                        </div>
                        <div style="width: 7.031vw; height: 7.086vw;">
                            <img src="images/home_page/client3.svg" alt="" />
                        </div>
                        <div style="width: 13.490vw; height: 4.688vw;">
                            <img src="images/home_page/client4.svg" alt="" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="slider-section">
                <div class="slider-section-title">
                    <h1 style="font-size: 3.229vw; color:rgba(25, 25, 25, 1);">
                        TESTIMONIALS:
                    </h1>
                </div>
                <div class="slider-section-des">
                    <h5>
                        Automason offers the best results in the construction
                        business. Here’s what satisfied contractors have to say
                        about our services.
                    </h5>
                </div>
            </div>
        </div>

        <div class="slider-part">
            <div class="slider-div">
                <div class="slide-main-div">
                    <div class="extra-outer-wrapper">
                        <div class="outer-wrapper">
                            <div class="inner-wrapper">
                                <div class="slide-background">
                                    <div class="slide">
                                        {#each slides as slide, id}
                                            <div
                                                class="main_div"
                                                transition:fade={{
                                                    duration: 200,
                                                }}
                                            >
                                                <div
                                                    class="outer_div {currentAnim}"
                                                >
                                                    <div class="slider-outer">
                                                        <div class="slider-img">
                                                            <img
                                                                src={slide.slider_img}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div class="slider-des">
                                                            <div
                                                                class="des-para"
                                                            >
                                                                <div
                                                                    class="coma-img"
                                                                >
                                                                    <img
                                                                        src="images/home_page/opening_comas.svg"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="des-text"
                                                                >
                                                                    <h5
                                                                        style="color:white; margin:0vw; font-size:1vw;"
                                                                    >
                                                                        {slide.des}
                                                                    </h5>
                                                                </div>
                                                                <div
                                                                    class="coma-img"
                                                                    style=" margin-left: 34.9vw;"
                                                                >
                                                                    <img
                                                                        src="images/home_page/closing_comas.svg"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="person-name"
                                                            >
                                                                <p
                                                                    style="font-size: 1.042vw;font-weight:600 ; color:white; margin:0;"
                                                                >
                                                                    {slide.name}
                                                                </p>
                                                            </div>
                                                            <div
                                                                class="company-job"
                                                            >
                                                                <p
                                                                    style="font-size: 1.042vw;color:white; margin:0; opacity: 70%;"
                                                                >
                                                                    {slide.job_company}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="controls">
                <button
                    class="button1"
                    on:click={() => {
                        prev();
                    }}
                >
                    &larr;
                </button>
                <div class="dots">
                    <div class={cur === 0 ? "selected" : "dot"} />
                    <div class={cur === 1 ? "selected" : "dot"} />
                    <div class={cur === 2 ? "selected" : "dot"} />
                    <div class={cur === 3 ? "selected" : "dot"} />
                    <div class={cur === 4 ? "selected" : "dot"} />
                </div>
                <button
                    class="button2"
                    on:click={() => {
                        next();
                    }}
                    dot:selected={cur}
                >
                    &rarr;
                </button>
            </div>
        </div>
    </div>

    <div class="mobile">
        <div style="position: relative;">
            <div class="section-1" style="margin-top: 14.953vw;">
                <p class="heading" style="color: rgba(0, 0, 0, 1);">
                    We strive to provide you with affordable rates and market
                    effective strategies to bid and close projects.
                </p>
                <p
                    class="text"
                    style="color:
                rgba(0, 0, 0, 1);"
                >
                    We know that your time is limited so we make sure to have
                    quick results with high accuracy.
                </p>
                <div>
                    <div class="circle-mbl">
                        <img
                            src="/images/home_page/circle.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="map-mbl">
                        <img
                            src="/images/home_page/map.png"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div class="card-left" style="height: 30.755vw;">
                        <p class="card-text">
                            Estimator <br /> Network
                        </p>
                        <div class="card-inner-img">
                            <img
                                src="/images/home_page/card1.png"
                                alt=""
                                width="100%"
                            />
                            <div class="projects-mbl">
                                <div
                                    class="project-img-mbl"
                                    style="top: -2.9vw;
                                position: relative;"
                                >
                                    <img
                                        src="/images/home_page/star.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    class="project-text-mbl"
                                    style="font-size: 1.869vw;
                                margin-left: 1.2vw;
                                position: relative;
                                top: -1.7vw;"
                                >
                                    <h2>40+ Projects</h2>
                                </div>
                            </div>
                            <div
                                class="project-status-mbl"
                                style="position: relative;
                            top: -6.1vw;"
                            >
                                <p>Completed</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-right" style="height: 30.755vw;">
                        <p class="card-text">
                            Dynamic<br />Takeoffs
                        </p>
                        <div class="card-inner-img">
                            <img
                                src="/images/home_page/card2.png"
                                alt=""
                                width="100%"
                            />
                            <div class="projects-mbl">
                                <div
                                    class="project-img-mbl"
                                    style="top: -2.9vw;
                                position: relative;"
                                >
                                    <img
                                        src="/images/home_page/star.svg"
                                        alt=""
                                        width="100%"
                                    />
                                </div>
                                <div
                                    class="project-text-mbl"
                                    style="font-size: 1.869vw;
                                margin-left: 1.2vw;
                                position: relative;
                                top: -1.7vw;"
                                >
                                    <h2>10+ Years</h2>
                                </div>
                            </div>
                            <div
                                class="project-status-mbl"
                                style="position: relative;
                            top: -6.1vw;"
                            >
                                <p>Experience</p>
                            </div>
                        </div>
                    </div>
                </div>

                <p
                    style="font-size: 4.206vw;color:#4E413B;font-weight:500;padding-top:11.682vw;text-align: center;"
                >
                    WHY CHOOSE US
                </p>
                <p class="heading">
                    We strive to make your project a construction masterpiece,
                    something unique and unrivaled.
                </p>
                <p class="text">
                    We help you work the numbers when you’re negotiating, and
                    even jump on a conference call with your client (as your
                    estimating team) to help you close.
                    <br /><br />
                    We even advise you on exactly WHAT TO DO to have them wanting
                    to USE YOU instead of your competitor.
                </p>
                <div
                    style="justify-content: center; display: flex;
                margin-top: 5.841vw;"
                >
                    <Button
                        border_radius="2.07vw"
                        padding="2.804vw 8.879vw"
                        title="Explore Now"
                        me="2"
                        btnStyle="nav_bar_btn_mobile"
                        px="0"
                        href="#our_service"
                    />
                </div>
                <div style="background-color: black; margin-top:13.785vw;">
                    <div class="icon-mbl">
                        <img
                            src="/images/home_page/light_icon.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div style="padding:7.009vw 0vw">
                        <p class="heading" style="color: white;">
                            Most contractors are missing out on over $200,000
                            per month in project contracts and they don’t even
                            know it.
                        </p>

                        <p class="text" style="color: white;">
                            They are busy, have no time for estimating, and they
                            are leaving money on the table. A lot of money. We
                            designed our construction estimating service with
                            the goal of helping our clients win projects and
                            ultimately be successful
                        </p>
                    </div>
                </div>
            </div>
            <div style="position: relative;height: 80vw;">
                <div
                    style="width: 30.841vw;position: absolute;top: 20.093vw; left: 57.944vw;"
                >
                    <img
                        src="images/home_page/Stroke1.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="width: 25vw;position: absolute;left: 58.645vw;top: 25vw;"
                >
                    <img
                        src="images/home_page/Stroke.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="width: 42.084vw;position: absolute;left: 39.514vw;
                top: 40.748vw;filter: drop-shadow(8px 8px 32px rgba(0, 0, 0, 0.25));"
                >
                    <img
                        src="images/home_page/construction_business.png"
                        alt=""
                        width="100%"
                    />
                </div>
                <div
                    style="width: 42.084vw;position: absolute;left: 22.514vw;
                top: 19.748vw;filter: drop-shadow(8px 8px 32px rgba(0, 0, 0, 0.25));"
                >
                    <img
                        src="images/home_page/construction_site.png"
                        alt=""
                        width="100%"
                    />
                </div>
            </div>
            <div>
                <p class="heading" style="font-size: 4.206vw;">
                    It works for any <br /> construction business.
                </p>
                <p class="text" style="color: black;">
                    These aren’t strategies we made up – we listened to our
                    clients and created our blueprint based on what they are
                    doing right, and avoiding what they were doing wrong.
                </p>
            </div>
            <!-- <div
                style="display: flex;margin-top: 4.215vw;justify-content: center;align-items: center;"
            >
                <div>
                    <p style="font-size:2.804vw;color:#F36532;font-weight:500;">
                        Learn More
                    </p>
                </div>

                <div style="width: 4vw;margin-left: 4vw;">
                    <img src="images/home_page/arrow.svg" alt="" width="100%" />
                </div>
            </div> -->
            <div style="margin-top: 9.346vw;">
                <hr class="hr-css" />
            </div>
            <div class="section2" style="margin-top: 9.346vw;">
                <p class="heading2">WE WORK WITH</p>
            </div>
            <div style=" margin-top: 5.4vw;">
                <div class="gallery-mbl">
                    {#each work_with as data}
                        <div class="gallery_tab-mbl">
                            <img src={data.src} alt="" />
                            <div class="title-mbl">
                                <p
                                    style="font-size: 2.804vw;font-weight:700;color:white;"
                                >
                                    {@html data.title}
                                </p>
                            </div>
                        </div>
                    {/each}
                </div>
            </div>
            <div style="margin-top: 5vw;">
                <p class="text">
                    We work with industry professionals that provide you with
                    error-free results. If you’re a homebuilder, builder,
                    architect or a sub-contractor, you’ve come to the right
                    place.
                </p>
            </div>
            <div
                style="justify-content: center;
            display: flex;
            margin-top: 7.009vw;"
            >
                <PopUpButton
                    border_radius="2.07vw"
                    padding="2.804vw 8.879vw"
                    title="Get Started"
                    me="2"
                    btnStyle="nav_bar_btn_mobile"
                    px="0"
                    on:click={() => {
                        displayPopUp();
                    }}
                />
            </div>
            <div style="margin-top: 9.346vw;">
                <hr class="hr-css" />
            </div>
            <div class="section2" style="margin-top: 9.346vw;">
                <span id="our_service" />
                <p class="heading2">OUR SERVICES</p>
            </div>
            {#each our_services_mbl as service}
                <div
                    class="services-mbl"
                    style="display: flex; padding: 7vw 8vw;"
                >
                    <div style="width:40vw;">
                        <div class="services-mbl-image">
                            <img src={service.icon} alt="" width="100%" />
                        </div>
                        <div class="services-mbl-heading">
                            <p>{@html service.title}</p>
                        </div>
                    </div>
                    <div style="width:52vw;">
                        <div class="services-mbl-text">
                            <p>
                                {@html service.description}
                            </p>
                        </div>
                        <div
                            style="display: flex;margin-top: 4.215vw;align-items: center; cursor: pointer;"
                        >
                            <p
                                style="font-size:2.336vw;color:#F36532;font-weight:500;"
                                on:click={(e) => {
                                    if (service.pagelink !== "")
                                        location.href = service.pagelink;
                                }}
                            >
                                Learn More
                            </p>

                            <div style="width: 4vw;margin-left: 4vw;">
                                <img
                                    src="images/home_page/arrow.svg"
                                    alt=""
                                    width="100%"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="outer-mbl"
                    style="border:{service.border_color};border-right:none;"
                >
                    <div style="display: flex;">
                        <div>
                            <ul
                                class="service-ul"
                                style="padding: 2vw 0vw 2vw 9vw;"
                            >
                                {#each service.list_items1 as info1}
                                    <li
                                        style="line-height: 0.5vw;font-size: 3vw;"
                                    >
                                        <p
                                            style="width: 36.888vw; font-size:2.336vw;font-weight:400;line-height: 2.5vw;"
                                        >
                                            {@html info1}
                                        </p>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                        <div>
                            <ul
                                class="service-ul"
                                style="padding: 2vw 6vw 2vw 5vw;"
                            >
                                {#each service.list_items2 as info2}
                                    <li
                                        style="line-height: 0.5vw;font-size: 3vw;"
                                    >
                                        <p
                                            style="width: 36.888vw; font-size:2.336vw;font-weight:400;line-height: 2.5vw;"
                                        >
                                            {@html info2}
                                        </p>
                                    </li>
                                {/each}
                            </ul>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 55.346vw;">
                    <hr class="hr-css" />
                </div>
            {/each}

            <div
                class="services-mbl-heading"
                style="margin-left: auto; margin-right: auto;justify-content: center;"
            >
                <p style="margin-left: 0;">FEATURED CLIENTS</p>
            </div>

            <div class="clients-logo-background-mbl">
                <div class="client-logos-mbl">
                    <div style="width: 8.864vw; height:7.257vw;">
                        <img
                            src="images/home_page/client1.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div style="width: 4.355vw; height: 7.206vw;">
                        <img
                            src="images/home_page/client2.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div style="width: 6.998vw; height:7.051vw;">
                        <img
                            src="images/home_page/client3.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                    <div
                        style="width: 11.916vw; height:3.972vw; margin-top: -1.8vw;"
                    >
                        <img
                            src="images/home_page/client4.svg"
                            alt=""
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div
                class="services-mbl-heading"
                style="margin-left: auto; margin-right: auto;justify-content: center;"
            >
                <p style="margin-left: 0;">TESTIMONIALS:</p>
            </div>
            <div style="margin-top: 5vw;">
                <p class="text">
                    Automason offers the best results in the construction
                    business. Here’s what satisfied contractors have to say
                    about our services.
                </p>
            </div>
        </div>

        <div class="slider-part-mob">
            <div class="slider-div-mob">
                <div class="slide-main-div-mob">
                    <div class="extra-outer-wrapper-mob">
                        <div class="outer-wrapper-mob">
                            <div
                                class="inner-wrapper-mob"
                                bind:this={scrol}
                                on:scroll={() => {
                                    console.log(scrol.scrollLeft);
                                    if (scrol.scrollLeft < 250) {
                                        cur_mob = 0;
                                    } else if (scrol.scrollLeft < 500) {
                                        cur_mob = 1;
                                    } else if (scrol.scrollLeft < 885) {
                                        cur_mob = 2;
                                    } else if (scrol.scrollLeft <= 1200) {
                                        cur_mob = 3;
                                    } else if (scrol.scrollLeft >= 1260) {
                                        cur_mob = 4;
                                    }
                                }}
                            >
                                <div class="slide-background-mob">
                                    <div class="slide-mob">
                                        {#each slides_mob as slide, id}
                                            <div
                                                class="main_div_mob_{id}"
                                                transition:fade={{
                                                    duration: 200,
                                                }}
                                            >
                                                <div
                                                    class="outer_div_mob {currentAnim}"
                                                >
                                                    <div
                                                        class="slider-outer-mob"
                                                    >
                                                        <div class="slider-img">
                                                            <img
                                                                src={slide.slider_img}
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div class="slider-des">
                                                            <div
                                                                class="des-para"
                                                            >
                                                                <div
                                                                    class="coma-img"
                                                                >
                                                                    <img
                                                                        src="images/home_page/opening_comas.svg"
                                                                        alt=""
                                                                        style="    position: relative;
                                                                    top: -5vw;
                                                                    left: -1.85vw;"
                                                                    />
                                                                </div>
                                                                <div
                                                                    class="des-text"
                                                                >
                                                                    <h5
                                                                        style="color:white; margin:0vw; font-size:1vw;"
                                                                    >
                                                                        {@html slide.des}
                                                                    </h5>
                                                                </div>
                                                                <div
                                                                    class="coma-img"
                                                                    style="    margin-left: 43.9vw;
                                                                margin-top: -8vw;"
                                                                >
                                                                    <img
                                                                        src="images/home_page/closing_comas.svg"
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="person-name"
                                                            >
                                                                <p
                                                                    style="font-size: 1.042vw;font-weight:600 ; color:white; margin:0;"
                                                                >
                                                                    {@html slide.name}
                                                                </p>
                                                            </div>
                                                            <div
                                                                class="company-job"
                                                            >
                                                                <p
                                                                    style="font-size: 1.042vw;color:white; margin:0; opacity: 70%;"
                                                                >
                                                                    {@html slide.job_company}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        {/each}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="controls_mob">
                <button
                    class="button1"
                    on:click={() => {
                        prevslide();
                    }}
                >
                    &larr;
                </button>
                <div class="dots_mob" bind:this={dots_con}>
                    <div class={cur_mob === 0 ? "selected_mob" : "dot_mob"} />
                    <div class={cur_mob === 1 ? "selected_mob" : "dot_mob"} />
                    <div class={cur_mob === 2 ? "selected_mob" : "dot_mob"} />
                    <div class={cur_mob === 3 ? "selected_mob" : "dot_mob"} />
                    <div class={cur_mob === 4 ? "selected_mob" : "dot_mob"} />
                </div>
                <button
                    class="button2"
                    title="Next"
                    transition:fade={{
                        duration: 200,
                    }}
                    on:click={() => {
                        nextslide();
                    }}
                    dot_mob:selected_mob={cur_mob}
                >
                    &rarr;
                </button>
            </div>
        </div>
    </div>

    <div class="desktop">
        <div class="last-section">
            <div class="left-side">
                <div class="top-icon">
                    <img
                        src="images/home_page/last_section_icon.svg"
                        alt=""
                        width="100%"
                    />
                </div>
                <div class="cost-experts">
                    <h2 style="width: 35vw;
                    font-size: 2.188vw;
                    margin: 0px;">
                        A global netwok of construction cost experts.
                    </h2>
                </div>
                <div class="cost-experts-des">
                    <h5>
                        Over the last 10 years, and after speaking and working
                        with THOUSANDS of Contractors, we get to see what WORKS
                        and what DOESN’T. We have some clients landing 50% of
                        their bids by implementing some of the strategies we can
                        easily show you.
                    </h5>
                </div>
            </div>
            <div class="right-side">
                <div class="cost-expert-graphs">
                    <img src="images/home_page/illustration.svg" alt="" />
                </div>
            </div>
        </div>
    </div>
    <div class="mobile">
        <div style="margin-bottom: 16.355vw;">
            <div class="top-icon-mbl">
                <img
                    src="images/home_page/last_section_icon.svg"
                    alt=""
                    width="100%"
                />
            </div>
            <div>
                <p
                    style="font-size: 3.271vw; font-weight:600;text-align: center;"
                >
                    A global netwok of construction <br /> cost experts.
                </p>
            </div>
            <div style="width: 75.935vw; margin:auto;">
                <p class="text" style="color:#525D73;">
                    Over the last 10 years, and after speaking and working with
                    THOUSANDS of Contractors, we get to see what WORKS and what
                    DOESN’T. We have some clients landing 50% of their bids by
                    implementing some of the strategies we can easily show you.
                </p>
            </div>
        </div>
    </div>
    <Footer />
</section>

<style>
    .title {
        width: fit-content;
    margin: auto;
    }
    .des {
        width: 36.642vw;
        height: 3.534vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1.455vw;
        text-align: center;
    }
    .person-name {
        margin-top: 2.344vw;
        margin-left: 3.698vw;
        text-align: start;
    }
    .company-job {
        margin-left: 3.698vw;
        text-align: start;
        margin-top: 0.781vw;
    }
    .images-text {
        display: flex;
    }
    .circle-img {
        position: relative;
        width: 31.146vw;
        height: 29vw;
        left: 15vw;
        top: 12vw;
    }
    .circle-mbl {
        position: relative;
        width: 62.077vw;
        margin: auto;
        margin-top: 21.262vw;
    }
    .map-img {
        position: absolute;
        width: 22.8vw;
        margin-left: 19vw;
        margin-top: -26vw;
    }
    .map-mbl {
        position: absolute;
        width: 44.353vw;
        left: 27.8vw;
        top: 39.5vw;
    }
    .card-left {
        width: 21.145vw;
        background: #ffffff;
        box-shadow: 0px 30px 100px -10px rgba(86, 0, 0, 0.08);
        border-radius: 2.804vw;
        position: absolute;
        left: 13vw;
        top: 84vw;
    }
    .card-right {
        width: 21.145vw;
        background: #ffffff;
        box-shadow: 0px 30px 100px -10px rgba(86, 0, 0, 0.08);
        border-radius: 2.804vw;
        position: absolute;
        left: 66vw;
        top: 67vw;
    }
    .card-text {
        font-size: 1.869vw;
        font-weight: 700;
        text-align: center;
        padding: 1vw 0vw;
    }
    .card-inner-img {
        width: 16.336vw;
        padding: 0vw 0.5vw;
        margin: auto;
    }
    .card-1 {
        position: absolute;
        left: 11.8vw;
        margin-top: -1vw;
    }
    .card-2 {
        position: absolute;
        left: 38.7vw;
        margin-top: -8.5vw;
    }
    .choose-us-img {
        margin-top: 12vw;
        margin-left: -1vw;
        width: 9.635vw;
        height: 1.719vw;
    }
    .choose-us-img img {
        width: 100%;
        height: 100%;
    }
    .choose-us-para {
        width: 29.262vw;
        height: 9.356vw;
        margin-top: -1vw;
        display: flex;
        gap: 2vw;
        flex-direction: column;
    }
    .project-contracts {
        width: 99.99vw;
        height: 17.36vw;
        background-color: #191919;
        margin-top: 14.576vw;
        overflow: hidden;
        display: flex;
        margin-bottom: 14.657vw;
        gap: 6.081vw;
    }
    .icon {
        width: 4.5vw;
        height: 4.5vw;
        margin-top: 5vw;
        margin-left: 23.285vw;
    }
    .icon-mbl {
        width: 10.178vw;
        margin: auto;
        padding-top: 10.234vw;
    }
    .card-layout {
        background-color: white;
        width: 10.603vw;
        height: 12.8vw;
        border-radius: 0.624vw;
        box-shadow: 0px 30px 100px -10px rgba(86, 0, 0, 0.08);
    }
    .card-layout .title {
        width: 9vw;
        padding-top: 1.559vw;
        justify-content: center;
    }
    .card-layout .title h2 {
        font-size: 0.936vw;
        margin: 0;
    }
    .card-layout .des h4 {
        font-size: 0.624vw;
        margin: 0;
    }
    .card-layout .card-img {
        width: 6.549vw;
        height: 3.794vw;
        box-shadow: 0px 30px 50px -15px rgb(201 29 52 / 20%);
        justify-items: center;
        margin-left: auto;
        margin-right: auto;
        padding-top: 1.5vw;
    }
    .projects {
        display: flex;
        margin-top: 1.5vw;
        gap: 0.676vw;
    }
    .projects .project-img {
        width: 0.832vw;
        height: 0.832vw;
        justify-items: center;
        margin-top: auto;
        margin-bottom: auto;
        margin-left: 1.04vw;
    }
    .projects .project-text h2 {
        font-size: 1vw;
        margin: 0;
    }
    .project-status {
        margin-left: 2.703vw;
        margin-top: -0.3vw;
    }
    .project-status h4 {
        margin: 0;
    }
    .projects-mbl {
        display: flex;
        margin-top: 1.5vw;
        gap: 0.676vw;
    }
    .projects-mbl .project-img-mbl {
        width: 1.832vw;
        justify-items: center;
        margin-top: auto;
        margin-bottom: auto;
    }
    .projects-mbl .project-text-mbl {
        font-size: 1.869vw;
        margin-left: 2vw;
    }
    .project-status-mbl {
        text-align: center;
    }
    .project-status-mbl p {
        font-size: 1.869vw;
    }
    .construction-business {
        display: flex;
        margin-bottom: 12.5vw;
    }
    .construction-business-img {
        width: 27.448vw;
        height: 18.333vw;
        border-radius: 1.563vw;
        margin-left: 16.51vw;
        margin-top: 10.5vw;
        position: absolute;
    }
    .construction-business-img img {
        width: 100%;
        height: 100%;
        border-radius: 1.563vw;
    }
    .construction-site-img {
        width: 27.031vw;
        height: 18.333vw;
        border-radius: 1.563vw;
        margin-left: 7.6vw;
        position: absolute;
    }
    .construction-site-img img {
        width: 100%;
        height: 100%;
        border-radius: 1.563vw;
    }
    .stroke1 {
        margin-left: 26.781vw;
        width: 17vw;
        height: 17vw;
        margin-top: 2vw;
        position: absolute;
        border: 0.9vw solid rgba(133, 118, 113, 0.7);
        transform: rotate(-90deg);
        border-radius: 70%;
    }
    .stroke2 {
        margin-left: 28vw;
        width: 13.7vw;
        height: 13.7vw;
        margin-top: 4.1vw;
        position: absolute;
        border: 0.9vw solid rgba(255, 109, 36, 0.7);
        transform: rotate(-90deg);
        border-radius: 70%;
    }
    .work-with {
        width: 100vw;
        height: 54.167vw;
        background-color: #f9f6ef;
        display: flex;
    }
    .work-with-text {
        margin-left: 13.438vw;
        margin-top: 15vw;
    }
    .work-with-para {
        width: 30.313vw;
        margin-top: 3.5vw;
        display: flex;
        gap: 2vw;
        flex-direction: column;
    }
    .gallery {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 45.4vw;
        gap: 3.834vw;
    }
    .gallery-mbl {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 70vw;
        gap: 8.834vw;
    }
    .gallery_tab {
        border-radius: 1.563vw;
        overflow: hidden;
        position: relative;
        width: 12.654vw;
        height: 12.27vw;
    }
    .gallery_tab-mbl {
        border-radius: 1.563vw;
        overflow: hidden;
        position: relative;
        width: 30.231vw;
        height: 29.315vw;
    }
    .gallery_tab img {
        height: 100%;
        width: 100%;
    }
    .gallery_tab-mbl img {
        width: 100%;
    }
    .gallery_tab .title {
        position: absolute;
        bottom: 1vw;
        left: 1.151vw;
        z-index: 1;
        width: 10.698vw;
        text-align: start;
    }
    .gallery_tab-mbl .title-mbl {
        position: absolute;
        bottom: 0vw;
        left: 1.151vw;
        z-index: 1;
        width: 10.698vw;
        text-align: start;
    }
    .our-services-title {
        margin-top: 5.99vw;
        display: flex;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 3.438vw;
    }
    .our-services-dotted-img {
        width: 21.458vw;
        height: 1.823vw;
        position: absolute;
        margin-top: 2.7vw;
        margin-left: -3vw;
    }
    .our-services-dotted-img img {
        width: 100%;
    }
    .services {
        display: flex;
        gap: 4.167vw;
    }
    .services-detail {
        margin-left: 10.938vw;
        margin-top: 2.135vw;
    }
    .icon_text {
        width: 19.844vw;
        height: 5.781vw;
        display: flex;
        gap: 1.979vw;
        margin-bottom: 2.031vw;
    }
    .icon-wrapper {
        width: 5.781vw;
        height: 5.781vw;
    }
    .icon-wrapper img {
        width: 100%;
        height: 100%;
    }
    .icon-detail {
        width: 10.365vw;
        height: 5.625vw;
        text-align: start;
        display: flex;
        align-items: center;
    }
    .icon_des {
        width: 26.135vw;
        margin-bottom: 1.615vw;
    }
    .learn-more {
        width: 7.573vw;
        height: 1.2vw;
        display: flex;
        align-items: baseline;
        cursor: pointer;
    }
    .learn-more-arrow {
        width: 1.063vw;
        height: 0.591vw;
        align-items: center;
        margin-left: 0.5vw;
    }
    .learn-more-arrow img {
        width: 100%;
        height: 100%;
    }
    .outer-border {
        border: 0.104vw solid transparent;
        filter: drop-shadow(0vw 0.104vw 0.25vw rgba(0, 0, 0, 0.6));
        border-radius: 1.563vw 0vw 0vw 1.563vw;
        width: 57.917vw;
        height: 22.76vw;
        margin-bottom: 5.229vw;
        margin-top: 3vw;
        overflow: hidden;
        position: relative;
    }
    .services-content {
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: white;
        border-radius: 1.563vw 0vw 0vw 1.563vw;
    }
    .myli {
        list-style-type: disc;
        font-size: 0.7vw;
    }
    .left-right-list {
        margin-top: 3.948vw;
        width: 17.563vw;
        height: 13.125vw;
    }
    .featured-clients-dotted-img {
        width: 27.292vw;
        height: 4.844vw;
        margin-top: 6.198vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
    }
    .featured-clients-dotted-img img {
        width: 100%;
        height: 100%;
    }
    .clients-logo-background {
        width: 103vw;
        height: 17.396vw;
        margin-top: 1.927vw;
        margin-bottom: 9.531vw;
        background-color: black;
    }
    .client-logos {
        display: flex;
        gap: 13.021vw;
        margin: auto;
        justify-content: center;
        align-items: center;
        align-content: center;
        padding-top: 5.052vw;
    }
    .client-logos img {
        width: 100%;
        height: 100%;
    }
    .clients-logo-background-mbl {
        margin-top: 1.927vw;
        margin-bottom: 9.531vw;
        background-color: black;
    }
    .client-logos-mbl {
        display: flex;
        justify-content: space-between;
        align-items: center;
        align-content: center;
        padding: 3vw 15vw;
    }
    .slider-section-title {
        width: 24.51vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: -1.5vw;
        text-align: center;
    }
    .slider-section-des {
        width: 39vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        color: rgba(25, 25, 25, 1);
        margin-bottom: -2vw;
        text-align: center;
    }
    .extra-outer-wrapper {
        width: 100%;
        margin: 0 auto;
        height: 31vw;
    }
    .outer-wrapper {
        width: 100%;
        position: relative;
    }
    .inner-wrapper {
        width: 100%;
        display: flex;
        position: absolute;
        z-index: 0;
        overflow: hidden;
    }
    .slide-background {
        margin-top: 4.42vw;
        flex: 1 0 auto;
        align-items: center;
        text-align: center;
        background-color: white;
        width: 72.0625vw;
        margin-left: 14vw;
        border-radius: 2.6vw;
    }
    .slide {
        display: flex;
        gap: 21vw;
        align-items: center;
        text-align: center;
        overflow: visible;
    }
    .main_div {
        transition: transform 5s, opacity 2s;
    }
    .main_div .start {
        transform: translate(-9.5vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .main_div .nextSlide {
        transform: translate(-90.1vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .main_div .slidePrev {
        transform: translate(-170.9vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .main_div .nextSlide3 {
        transform: translate(-251.9vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .main_div .nextSlide4 {
        transform: translate(-329.9vw);
        transition-duration: 1s;
        opacity: 1;
    }
    .slider-outer {
        display: flex;
        margin: auto;
        width: 59.74vw;
        height: 26.042vw;
        justify-content: center;
    }
    .slider-img img {
        width: 100%;
        height: 100%;
        transform: scaleX(-1);
        border-radius: 0vw 1.563vw 1.563vw 0vw;
    }
    .slider-des {
        width: 45.74vw;
        height: 26.042vw;
        border-radius: 0vw 1.563vw 1.563vw 0vw;
        background-color: #ff6d24;
    }
    .controls {
        display: flex;
        justify-content: center;
        margin-top: -6vw;
        font-size: 3vw;
    }
    .controls .button1 {
        font-size: 3vw;
    }
    .controls .button2 {
        font-size: 3vw;
    }
    .dots {
        display: flex;
        align-items: center;
        gap: 0.507vw;
        width: 4.838vw;
        height: 0.608vw;
        margin-top: 2vw;
        margin-left: 3.438vw;
        margin-right: 3.438vw;
    }
    .dot {
        width: 0.608vw;
        height: 0.608vw;
        background: #000;
        border-radius: 50%;
        opacity: 0.3;
    }
    .selected {
        width: 0.608vw;
        height: 0.608vw;
        background: #000;
        border-radius: 50%;
        opacity: 1;
    }
    .des-para {
        width: 39.854vw;
        height: 12vw;
        margin-left: 2.395vw;
        margin-top: 5vw;
    }
    .coma-img {
        width: 2.605vw;
        height: 2.083vw;
    }
    .coma-img img {
        width: 100%;
        height: 100%;
    }
    .des-text {
        width: 36.656vw;
        margin-top: 1.042vw;
        text-align: start;
        margin-left: 1.5vw;
    }
    .last-section {
        width: 60.96vw;
        display: flex;
        height: 20vw;
        justify-content: center;
        margin-left: auto;
        margin-right: auto;
        margin-top: 8.75vw;
        margin-bottom: 11.146vw;
        gap: 2.828vw;
    }
    .left-side {
        width: 30.677vw;
    }
    .top-icon {
        width: 5.5vw;
        height: 5.5vw;
        margin-left: -0.8vw;
    }
    .top-icon-mbl {
        width: 25vw;
        margin: auto;
        margin-top: 10vw;
    }
    .cost-experts {
        width: 30.677vw;
        height: 5.417vw;
    }
    .cost-experts-des {
        width: 27.656vw;
        margin-top: 3vw;
    }
    .right-side {
        width: 28.132vw;
    }
    .cost-expert-graphs {
        width: 30.99vw;
        height: 27.593vw;
        margin-top: -1.5vw;
        margin-left: 3vw;

    }
    .cost-expert-graphs img {
        width: 100%;
        height: 100%;
    }
    .heading {
        font-size: 3.271vw;
        font-weight: 700;
        text-align: center;
        width: 79.439vw;
        margin: auto;
    }
    .heading2 {
        font-size: 5.607vw;
        font-weight: 700;
        text-align: center;
        width: 79.439vw;
        margin: auto;
        font-family: "Poppins";
    }
    .text {
        font-size: 3.271vw;
        text-align: center;
        padding-top: 5.841vw;
        width: 79.673vw;
        margin: auto;
    }
    .learn-btn {
        border: none;
        color: #ff6d24;
        background-color: transparent;
        font-size: 2.804vw;
        font-weight: 500;
    }
    .hr-css {
        width: 68.266vw;
        border: 0.134vw solid #eae7e7;
    }
    .services-mbl-image {
        width: 18.224vw;
        margin-top: 3vw;
        margin-left: 4vw;
    }
    .services-mbl-heading p {
        font-size: 4.206vw;
        font-weight: 700;
        text-align: center;
        margin-left: -12vw;
    }

    .services-mbl-text p {
        font-size: 2.336vw;
    }
    .outer-mbl {
        border-radius: 7.009vw 0px 0px 7.009vw;
        width: 94.393vw;
        border-right: none;
        float: right;
    }
    .slide-main-div {
        width: 70vw;
        margin: auto;
        height: 37vw;
    }
    .slider-div {
        width: 99vw;
        height: 37vw;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        .heading {
            font-size: 3.271vw;
            font-weight: 700;
            text-align: center;
            width: 75.439vw;
            margin: auto;
        }
        .text {
            font-size: 2.804vw;
            text-align: center;
            padding-top: 5.841vw;
            width: 79.673vw;
            margin: auto;
        }
        .slider-div-mob {
            height: 45vw !important;
        }
        .slide-main-div-mob {
            width: 100vw !important;
            /* 92vw */
        }

        .slide-mob {
            display: flex;
            gap: 8vw;
            margin-left: 9vw;
            align-items: center;
            text-align: center;
            overflow: visible;
        }
        .extra-outer-wrapper-mob {
            width: 100%;
            margin: auto;
            height: 31vw;
        }
        .outer-wrapper-mob {
            position: relative;
            width: 100%;
        }
        .slide-background-mob {
            /* margin-top: 4.42vw;
        flex: 1 0 auto;
        align-items: center;
        text-align: center;
        background-color: white;
        width: 72.0625vw;
        margin-left: 8vw;
        border-radius: 2.6vw; */

            margin-top: 4.42vw;
            /* flex: 1 0 auto; */
            align-items: center;
            text-align: center;
            margin-right: 10vw;
            background-color: white;
        }
        .inner-wrapper-mob {
            /* width: 100%;
            display: flex;
            position: absolute;
            z-index: 0;
            overflow-x: scroll;
            overflow-y: hidden;
            scroll-behavior: smooth; */
            width: 100%;
            display: flex;
            position: absolute;
            z-index: 0;
            overflow-x: scroll;
            overflow-y: hidden;
        }

        .inner-wrapper-mob::-webkit-scrollbar {
            display: none;
            width: 0 !important;
        }
        .slider-outer-mob {
            width: 82.74vw !important;
            height: 35.042vw !important;
            display: flex;
            margin: auto;
            justify-content: center;
        }
        .slider-img {
            width: 27vw !important;
            height: 35.042vw !important;
        }
        .slider-des {
            width: 51.74vw !important;
            height: 35.042vw !important;
        }
        .des-text {
            width: 45.656vw !important;
        }
        .des-text h5 {
            font-size: 1.6vw !important;
        }
        .person-name {
            margin-top: 8.344vw !important;
        }
        .person-name p {
            font-size: 1.804vw !important;
        }
        .company-job p {
            font-size: 1.804vw !important;
        }
        /* .main_div .nextSlide {
            transform: translate(-95.5vw) ;
        }
        .main_div .slidePrev {
            transform: translate(-183.5vw) ;
        }
        .main_div .nextSlide3 {
            transform: translate(-271.5vw) ;
        }
        .main_div .nextSlide4 {
            transform: translate(-359.9vw) ;
        } */
        /* .main_div_1{
            display: none;
        } */
        .controls_mob {
            justify-content: space-between !important;
            margin-top: -7vw !important;
            padding: 0vw 12vw;
            align-items: center;
            display: flex;
            font-size: 3vw;
        }
        .controls_mob .button1 {
            font-size: 9vw !important;
            /* font-size: 3vw; */
        }
        .controls_mob .button2 {
            font-size: 9vw !important;
        }
        .dots_mob {
            /* width: 11.838vw;
            margin-top: 2.9vw;
            margin-left: 6.438vw; */

            display: flex;
            align-items: center;
            gap: 0.507vw;
            width: 11.838vw;
            height: 0.608vw;
            margin-top: 2.9vw;
            margin-left: 6.438vw;
            margin-right: 3.438vw;
        }
        .dot_mob {
            width: 2vw;
            height: 2vw;
            background: #000;
            border-radius: 50%;
            opacity: 0.3;
        }
        .selected_mob {
            width: 2vw;
            height: 2vw;
            background: #000;
            border-radius: 50%;
            opacity: 1;
        }
    }
</style>
